import React, { useState, useEffect } from "react";
import { api } from "../../utils/api";
import { CircleAlert, ChevronRight } from "lucide-react";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // Site adı ve logo durumu
  const [siteName, setSiteName] = useState("Başkent Sitesi");
  const [logoSrc, setLogoSrc] = useState("/logo.jpg"); // Varsayılan olarak public/logo.jpg dosyasına bakar
  const [logoError, setLogoError] = useState(false);   // Logo bulunamazsa true olur ve baş harfe döner

  useEffect(() => {
    // Eğer ayarlarda kayıtlı özel bir site adı veya logo URL'si varsa çekmeyi dener
    api.get("/settings").then(r => {
      if (r.data) {
        if (r.data.site_name || r.data.siteName) {
          setSiteName(r.data.site_name || r.data.siteName);
        }
        if (r.data.logo_url) {
          setLogoSrc(r.data.logo_url);
          setLogoError(false);
        }
      }
    }).catch(() => {
      // Giriş yapılmadığı için /settings 401 dönerse varsayılan "Başkent Sitesi" ve "/logo.jpg" kalır
    });
  }, []);

  const submit = async e => {
    e.preventDefault();
    try {
      const r = await api.post("/auth/login", { email, password });
      onLogin(r.data);
    } catch (x) {
      const detail = x.response?.data?.detail;
      setError(
        Array.isArray(detail)
          ? detail.map(item => item.msg || "Geçersiz bilgi").join(" ")
          : typeof detail === "string"
          ? detail
          : "Giriş bilgilerini kontrol edin"
      );
    }
  };

  // Sitenin veya apartmanın ilk harfini büyük harf olarak al (Örn: "Başkent Sitesi" -> "B")
  const firstLetter = (siteName || "B").trim().charAt(0).toLocaleUpperCase("tr-TR");

  return (
    <main className="login-shell">
      <section className="login-art">
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span 
            className="brand-mark" 
            style={{ 
              overflow: "hidden", 
              display: "inline-flex", 
              alignItems: "center", 
              justifyContent: "center",
              padding: (!logoError && logoSrc) ? 0 : undefined,
              borderRadius: "50%" // Yuvarlak Başkent Sitesi logosunun tam oturması için
            }}
          >
            {!logoError && logoSrc ? (
              <img 
                src={logoSrc} 
                alt={siteName} 
                onError={() => setLogoError(true)} 
                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} 
              />
            ) : (
              firstLetter
            )}
          </span>
          <span className="eyebrow">{siteName}</span>
        </div>

        <div>
          <span className="eyebrow">
            <h1><em>Aidat Takip Sistemi</em></h1>
            <p>Yönetim Paneli</p>
          </span>
        </div>

        <div className="login-art-foot">
          Zeki KADI <span>•</span> 2026
        </div>
      </section>

      <section className="login-form">
        <div className="form-inner">
          <span className="eyebrow">YÖNETİCİ GİRİŞİ</span>
          <h2>Tekrar hoş geldiniz.</h2>
          <p className="muted">Site Aidat takip panelinize erişmek için giriş yapınız.</p>
          <form onSubmit={submit}>
            <label>
              E-posta adresi
              <input data-testid="login-email-input" value={email} onChange={e => setEmail(e.target.value)} type="email" required />
            </label>
            <label>
              Şifre
              <input data-testid="login-password-input" value={password} onChange={e => setPassword(e.target.value)} type="password" required />
            </label>
            {error && (
              <div className="error" data-testid="login-error">
                <CircleAlert size={16} />{error}
              </div>
            )}
            <button className="primary full" data-testid="login-submit-button">
              Panele giriş yap <ChevronRight size={17} />
            </button>
          </form>
          <small className="muted">Güvenli bağlantı · Paragon Site Yönetim Sistemi</small>
        </div>

        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <a href="/sakin" style={{ color: "#10b981", fontSize: "14px", fontWeight: "bold", textDecoration: "none" }}>
            Site Sakini Girişi İçin Tıklayın
          </a>
        </div>
      </section>
    </main>
  );
}